import api from './api';

export const authService = {
  /**
   * Authenticate with Google OAuth token
   * This is called after the user successfully logs in with Google on the frontend
   */
  loginWithGoogle: async (googleToken) => {
    try {
      const response = await api.post('/auth/google', {
        google_token: googleToken
      });

      // Backend returns: { success: true, data: { access_token, refresh_token, user_id }, message: ... }
      const { access_token, refresh_token, user_id } = response.data.data;

      // Store tokens in localStorage
      localStorage.setItem('accessToken', access_token);
      localStorage.setItem('refreshToken', refresh_token);
      localStorage.setItem('userId', user_id);

      // Fetch and store user info
      await authService.fetchCurrentUser();

      return response.data;
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  },

  /**
   * Fetch current user information
   */
  fetchCurrentUser: async () => {
    try {
      const response = await api.get('/auth/me');
      const user = response.data.data;
      localStorage.setItem('user', JSON.stringify(user));
      return user;
    } catch (error) {
      console.error('Failed to fetch user:', error);
      throw error;
    }
  },

  /**
   * Logout - clear tokens and call backend
   */
  logout: async () => {
    try {
      // Call backend to revoke refresh token
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Clear local storage regardless of API call result
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      localStorage.removeItem('userId');
    }
  },

  /**
   * Get current user from localStorage
   */
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  /**
   * Check if user is authenticated
   */
  isAuthenticated: () => {
    const token = localStorage.getItem('accessToken');
    const user = localStorage.getItem('user');
    return !!token && !!user;
  },

  /**
   * Refresh access token using refresh token
   */
  refreshToken: async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    if (!refreshToken) {
      throw new Error('No refresh token available');
    }

    const response = await api.post('/auth/refresh', {
      refresh_token: refreshToken
    });

    // Backend returns: { success: true, data: { access_token, expires_in } }
    const { access_token } = response.data.data;
    localStorage.setItem('accessToken', access_token);

    return response.data;
  }
};
